import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { FileText, Printer, Eye, Download, Users, Trophy, LayoutList } from 'lucide-react';

const Boletas = () => {
  const navigate = useNavigate();
  const [periodos, setPeriodos] = useState([]);
  const [aulas, setAulas] = useState([]);
  const [alumnos, setAlumnos] = useState([]);
  
  const [filtros, setFiltros] = useState({ periodoId: '', aulaId: '', alumnoId: '', formato: 'Automatico' });
  const [cargando, setCargando] = useState(false);
  const [pdfPreview, setPdfPreview] = useState(null);
  
  const [vistaActual, setVistaActual] = useState('pdf');
  const [consolidado, setConsolidado] = useState([]);
  const [cargandoConsolidado, setCargandoConsolidado] = useState(false);

  useEffect(() => { cargarPeriodos(); }, []);
  useEffect(() => { if (filtros.periodoId) cargarAulas(filtros.periodoId); }, [filtros.periodoId]);
  useEffect(() => { if (filtros.aulaId) cargarAlumnos(); }, [filtros.aulaId]);

  const cargarPeriodos = async () => {
    const token = localStorage.getItem('token');
    const res = await fetch(`${process.env.REACT_APP_API_URL}/Periodos`, { headers: { 'Authorization': `Bearer ${token}` } });
    if (res.ok) setPeriodos(await res.json());
  };

  const cargarAulas = async (periodoId) => {
    const token = localStorage.getItem('token');
    const res = await fetch(`${process.env.REACT_APP_API_URL}/Aulas/PorPeriodo/${periodoId}`, { headers: { 'Authorization': `Bearer ${token}` } });
    if (res.ok) setAulas(await res.json());
  };

  const cargarAlumnos = async () => {
    const token = localStorage.getItem('token');
    const res = await fetch(`${process.env.REACT_APP_API_URL}/Alumnos/PorAula/${filtros.periodoId}/${filtros.aulaId}`, { headers: { 'Authorization': `Bearer ${token}` } });
    if (res.ok) setAlumnos(await res.json());
  };

  const formatearNota = (notaNumero, nivelAula) => {
    if (notaNumero === 0) return "-";
    let usarLetras = filtros.formato === 'Letras' || (filtros.formato === 'Automatico' && (nivelAula.toLowerCase() === 'inicial' || nivelAula.toLowerCase() === 'primaria'));
    if (!usarLetras) return notaNumero.toFixed(2);
    if (notaNumero >= 17.5) return "AD";
    if (notaNumero >= 13.5) return "A";
    if (notaNumero >= 10.5) return "B";
    return "C";
  };

  const calcularPromedioBimestre = (cursoId, bimestre, data) => {
    const acts = (data.actividades || data.Actividades || []).filter(a => a.cursoId === cursoId && a.bimestre === bimestre);
    if (acts.length === 0) return 0;
    let notaFinal = 0;
    const criteriosSeguros = data.criterios || data.Criterios || [];
    const calificacionesSeguras = data.calificaciones || data.Calificaciones || [];

    criteriosSeguros.forEach(criterio => {
      const actsCriterio = acts.filter(a => a.criterioId === criterio.id);
      if (actsCriterio.length > 0) {
        let suma = 0, count = 0;
        actsCriterio.forEach(act => {
          const calif = calificacionesSeguras.find(c => c.actividadId === act.id);
          if (calif) { suma += calif.nota; count++; }
        });
        if (count > 0) notaFinal += (suma / count) * (criterio.porcentaje / 100);
      }
    });
    return notaFinal;
  };

  // --- NUEVA FUNCIÓN: Calcula el ranking en silencio ---
  const calcularRankingSilencioso = async () => {
    if (alumnos.length === 0) return [];
    const token = localStorage.getItem('token');
    let listaConsolidada = [];

    for (let i = 0; i < alumnos.length; i++) {
      const alumno = alumnos[i];
      const res = await fetch(`${process.env.REACT_APP_API_URL}/Reportes/Boleta/${filtros.periodoId}/${filtros.aulaId}/${alumno.id}`, { headers: { 'Authorization': `Bearer ${token}` } });
      if (res.ok) {
        const data = await res.json();
        const cursosLista = data.cursos || data.Cursos || [];
        let sumaPromedios = 0, cantCursos = 0;

        cursosLista.forEach(curso => {
          let nB1 = calcularPromedioBimestre(curso.id, "Bimestre 1", data);
          let nB2 = calcularPromedioBimestre(curso.id, "Bimestre 2", data);
          let notaFinalCurso = 0, div = 0;
          if (nB1 > 0) { notaFinalCurso += nB1; div++; }
          if (nB2 > 0) { notaFinalCurso += nB2; div++; }
          if (div > 0) { sumaPromedios += (notaFinalCurso / div); cantCursos++; }
        });
        
        listaConsolidada.push({
          id: alumno.id, nombreCompleto: `${alumno.apellidos}, ${alumno.nombres}`,
          promedioExacto: cantCursos > 0 ? (sumaPromedios / cantCursos) : 0,
          faltas: (data.asistencia || data.Asistencia || {}).faltas || 0
        });
      }
    }
    listaConsolidada.sort((a, b) => b.promedioExacto - a.promedioExacto);
    listaConsolidada.forEach((item, index) => item.puesto = index + 1);
    setConsolidado(listaConsolidada);
    return listaConsolidada;
  };

  const handleVerConsolidado = async () => {
    if (!filtros.periodoId || !filtros.aulaId) return alert("Selecciona Año y Aula.");
    setCargandoConsolidado(true);
    setVistaActual('consolidado');
    await calcularRankingSilencioso();
    setCargandoConsolidado(false);
  };

  // --- MOTOR DE DIBUJO ACTUALIZADO (Recibe puesto y total) ---
  const dibujarBoletaEnPDF = (doc, data, puestoAlumno, totalAlumnos) => {
    const alumnoObj = data.alumno || data.Alumno;
    const aulaObj = data.aula || data.Aula;
    const cursosLista = data.cursos || data.Cursos || [];
    const asistenciaObj = data.asistencia || data.Asistencia || { faltas: 0, tardanzas: 0 };
    const primaryColor = [30, 64, 175]; 
    
    doc.setFillColor(240, 240, 240);
    doc.roundedRect(14, 14, 25, 25, 2, 2, 'F');
    doc.setFontSize(8); doc.setTextColor(150); doc.text("LOGO", 26, 28, { align: 'center' });
    
    doc.setFontSize(20); doc.setTextColor(primaryColor[0], primaryColor[1], primaryColor[2]); doc.text("BOLETA DE CALIFICACIONES", 45, 24);
    doc.setFontSize(10); doc.setTextColor(100); doc.text("Documento Informativo del Progreso Académico", 45, 30); doc.text("Generado por EduControl", 45, 35);

    doc.setFillColor(248, 250, 252); doc.setDrawColor(226, 232, 240); doc.roundedRect(14, 45, 182, 32, 3, 3, 'FD');
    doc.setTextColor(71, 85, 105); doc.setFontSize(10); doc.setFont("helvetica", "bold");
    doc.text(`Estudiante:`, 20, 54); doc.text(`DNI:`, 20, 64); doc.text(`Nivel y Grado:`, 110, 54); 
    doc.text(`Orden de Mérito:`, 110, 64); // <-- NUEVO TEXTO
    
    doc.setFont("helvetica", "normal"); doc.setTextColor(15, 23, 42);
    doc.text(`${alumnoObj.apellidos}, ${alumnoObj.nombres}`, 45, 54);
    doc.text(`${alumnoObj.documentoIdentidad || 'No registrado'}`, 30, 64);
    doc.text(`${aulaObj.nivel} - ${aulaObj.grado} "${aulaObj.seccion}"`, 140, 54);
    
    // <-- INYECTAMOS EL ORDEN DE MÉRITO
    doc.setFont("helvetica", "bold"); doc.setTextColor(202, 138, 4); 
    doc.text(`${puestoAlumno}° Puesto (de ${totalAlumnos} alumnos)`, 140, 64);

    const filasTabla = cursosLista.map(curso => {
      let notaB1 = calcularPromedioBimestre(curso.id, "Bimestre 1", data);
      let notaB2 = calcularPromedioBimestre(curso.id, "Bimestre 2", data);
      let notaFinal = 0, div = 0;
      if (notaB1 > 0) { notaFinal += notaB1; div++; }
      if (notaB2 > 0) { notaFinal += notaB2; div++; }
      if (div > 0) notaFinal = notaFinal / div;
      return [curso.nombre, formatearNota(notaB1, aulaObj.nivel), formatearNota(notaB2, aulaObj.nivel), formatearNota(notaFinal, aulaObj.nivel)];
    });

    autoTable(doc, {
      startY: 84, head: [['Área / Curso', 'Bimestre 1', 'Bimestre 2', 'Promedio Final']], body: filasTabla, theme: 'grid',
      headStyles: { fillColor: primaryColor, textColor: 255, halign: 'center' },
      columnStyles: { 0: { fontStyle: 'bold', cellWidth: 80 }, 1: { halign: 'center' }, 2: { halign: 'center' }, 3: { halign: 'center', fontStyle: 'bold', fillColor: [240, 245, 255] } }
    });

    const finalY = doc.lastAutoTable.finalY + 15;
    doc.setFontSize(11); doc.setFont("helvetica", "bold"); doc.setTextColor(15, 23, 42); doc.text("Resumen de Asistencia:", 14, finalY);
    doc.setFontSize(10); doc.setFont("helvetica", "normal"); doc.setTextColor(220, 38, 38); doc.text(`Faltas: ${asistenciaObj.faltas || 0}`, 14, finalY + 7); doc.setTextColor(202, 138, 4); doc.text(`Tardanzas: ${asistenciaObj.tardanzas || 0}`, 40, finalY + 7);

    if (filtros.formato === 'Letras' || (filtros.formato === 'Automatico' && (aulaObj.nivel === 'Inicial' || aulaObj.nivel === 'Primaria'))) {
      doc.setTextColor(100); doc.setFontSize(8); doc.text("Leyenda de Calificaciones:", 110, finalY);
      doc.text("AD = Logro Destacado (18-20)   A = Logro Esperado (14-17)", 110, finalY + 5);
      doc.text("B = En Proceso (11-13)         C = En Inicio (0-10)", 110, finalY + 9);
    }

    doc.setDrawColor(150); doc.line(40, 250, 90, 250); doc.line(120, 250, 170, 250);
    doc.setTextColor(100); doc.setFontSize(9); doc.text("Firma del Docente / Tutor", 65, 255, { align: 'center' }); doc.text("Firma de la Dirección", 145, 255, { align: 'center' });
  };

  const handlePrevisualizar = async () => {
    if (!filtros.alumnoId) return alert("Selecciona un alumno.");
    setCargando(true);
    setVistaActual('pdf'); 
    try {
      let rankingActual = consolidado;
      if (rankingActual.length === 0) rankingActual = await calcularRankingSilencioso(); // Calculamos ranking si no existe

      const token = localStorage.getItem('token');
      const res = await fetch(`${process.env.REACT_APP_API_URL}/Reportes/Boleta/${filtros.periodoId}/${filtros.aulaId}/${filtros.alumnoId}`, { headers: { 'Authorization': `Bearer ${token}` } });
      const data = await res.json();
      
      const puesto = rankingActual.find(r => r.id === parseInt(filtros.alumnoId))?.puesto || '-';
      
      const doc = new jsPDF();
      dibujarBoletaEnPDF(doc, data, puesto, rankingActual.length);
      setPdfPreview(doc.output('datauristring')); 
    } catch (e) { alert("Error al cargar datos."); } finally { setCargando(false); }
  };

  const handleDescargar = async () => {
    if (!filtros.alumnoId) return;
    setCargando(true);
    try {
      let rankingActual = consolidado;
      if (rankingActual.length === 0) rankingActual = await calcularRankingSilencioso();

      const token = localStorage.getItem('token');
      const res = await fetch(`${process.env.REACT_APP_API_URL}/Reportes/Boleta/${filtros.periodoId}/${filtros.aulaId}/${filtros.alumnoId}`, { headers: { 'Authorization': `Bearer ${token}` } });
      const data = await res.json();
      const puesto = rankingActual.find(r => r.id === parseInt(filtros.alumnoId))?.puesto || '-';

      const doc = new jsPDF();
      dibujarBoletaEnPDF(doc, data, puesto, rankingActual.length);
      doc.save(`Boleta_${data.alumno?.apellidos || 'Estudiante'}.pdf`);
    } catch (e) { alert("Error."); } finally { setCargando(false); }
  };

  const handleDescargarGrupal = async () => {
    if (alumnos.length === 0) return alert("No hay alumnos en esta aula.");
    if(!window.confirm(`Se generará un único archivo PDF con las boletas de los ${alumnos.length} alumnos de esta aula. ¿Deseas continuar?`)) return;

    setCargando(true);
    try {
      let rankingActual = consolidado;
      if (rankingActual.length === 0) rankingActual = await calcularRankingSilencioso();

      const token = localStorage.getItem('token');
      const doc = new jsPDF(); 

      for (let i = 0; i < alumnos.length; i++) {
        const alumno = alumnos[i];
        const res = await fetch(`${process.env.REACT_APP_API_URL}/Reportes/Boleta/${filtros.periodoId}/${filtros.aulaId}/${alumno.id}`, { headers: { 'Authorization': `Bearer ${token}` } });
        if (res.ok) {
          const data = await res.json();
          const puesto = rankingActual.find(r => r.id === alumno.id)?.puesto || '-';
          dibujarBoletaEnPDF(doc, data, puesto, rankingActual.length); 
        }
        if (i < alumnos.length - 1) doc.addPage();
      }

      const aulaInfo = aulas.find(a => a.id === parseInt(filtros.aulaId));
      doc.save(`Boletas_Grupal_${aulaInfo?.grado}_${aulaInfo?.seccion}.pdf`);

    } catch (e) { console.error(e); alert("Hubo un error al compilar el documento grupal."); } 
    finally { setCargando(false); }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex">
      <Sidebar />
      <main className="flex-1 p-8 overflow-y-auto">
        <header className="mb-8 flex flex-col md:flex-row justify-between items-start md:items-end gap-4">
          <div>
            <h1 className="text-3xl font-bold text-slate-800 flex items-center gap-2"><FileText className="text-blue-600" /> Centro de Reportes</h1>
            <p className="text-slate-500 mt-1">Genera boletas y visualiza el Orden de Mérito del aula.</p>
          </div>
          <button onClick={handleDescargarGrupal} disabled={cargando || alumnos.length === 0} className="bg-green-600 text-white px-5 py-2.5 rounded-lg font-bold hover:bg-green-700 disabled:bg-slate-300 disabled:cursor-not-allowed flex items-center gap-2 shadow-md transition-colors">
            <Printer size={20} /> {cargando ? 'Generando lote...' : 'Imprimir PDF del Salón'}
          </button>
        </header>

        <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
          <div className="xl:col-span-1 bg-white p-6 rounded-xl shadow-sm border border-slate-200 h-fit space-y-4">
            <h2 className="font-bold text-slate-800 border-b pb-2 mb-4">Configuración del Reporte</h2>
            
            <div><label className="block text-xs font-bold text-slate-500 mb-1">Año Escolar</label>
              <select value={filtros.periodoId} onChange={e => {setFiltros({...filtros, periodoId: e.target.value}); setPdfPreview(null); setConsolidado([]);}} className="w-full p-2.5 border rounded-lg bg-slate-50 text-sm outline-none">
                <option value="">Seleccionar</option>{periodos.map(p => <option key={p.id} value={p.id}>{p.nombre}</option>)}
              </select>
            </div>
            
            <div><label className="block text-xs font-bold text-slate-500 mb-1">Aula / Salón</label>
              <select value={filtros.aulaId} onChange={e => {setFiltros({...filtros, aulaId: e.target.value}); setPdfPreview(null); setConsolidado([]);}} disabled={!filtros.periodoId} className="w-full p-2.5 border rounded-lg bg-slate-50 text-sm disabled:opacity-50 outline-none">
                <option value="">Seleccionar</option>{aulas.map(a => <option key={a.id} value={a.id}>{a.grado} "{a.seccion}"</option>)}
              </select>
            </div>
            
            <div className="pt-2 border-t mt-4">
              <button onClick={handleVerConsolidado} disabled={!filtros.aulaId || cargandoConsolidado} className="w-full bg-amber-500 text-white p-2.5 rounded-lg font-bold hover:bg-amber-600 flex items-center justify-center gap-2 disabled:bg-slate-300 text-sm transition-colors shadow-sm">
                <Trophy size={16} /> {cargandoConsolidado ? 'Calculando méritos...' : 'Ver Orden de Mérito'}
              </button>
            </div>

            <div className="pt-4 border-t mt-4"><label className="block text-xs font-bold text-slate-500 mb-2">Impresión Individual</label>
              <select value={filtros.alumnoId} onChange={e => {setFiltros({...filtros, alumnoId: e.target.value}); setPdfPreview(null);}} disabled={!filtros.aulaId} className="w-full p-2.5 border rounded-lg bg-slate-50 text-sm disabled:opacity-50 outline-none mb-3">
                <option value="">-- Seleccionar Estudiante --</option>{alumnos.map(a => <option key={a.id} value={a.id}>{a.apellidos}, {a.nombres}</option>)}
              </select>
              <select value={filtros.formato} onChange={e => setFiltros({...filtros, formato: e.target.value})} className="w-full p-2.5 border rounded-lg bg-slate-50 text-sm outline-none font-medium mb-3">
                <option value="Automatico">🤖 Formato Automático</option><option value="Numeros">🔢 Forzar Números (0-20)</option><option value="Letras">🔠 Forzar Letras (AD, A, B, C)</option>
              </select>

              <div className="flex flex-col gap-2">
                <button onClick={handlePrevisualizar} disabled={cargando || !filtros.alumnoId} className="w-full bg-slate-800 text-white p-2.5 rounded-lg font-medium hover:bg-slate-900 flex items-center justify-center gap-2 disabled:bg-slate-400 text-sm transition-colors">
                  <Eye size={16} /> Previsualizar Boleta
                </button>
                <button onClick={handleDescargar} disabled={!filtros.alumnoId} className="w-full bg-blue-100 text-blue-700 p-2.5 rounded-lg font-medium hover:bg-blue-200 flex items-center justify-center gap-2 disabled:opacity-50 text-sm transition-colors border border-blue-300">
                  <Download size={16} /> Descargar PDF Individual
                </button>
              </div>
            </div>
          </div>

          <div className="xl:col-span-2 bg-white rounded-xl shadow-sm border border-slate-200 flex flex-col min-h-[600px] overflow-hidden">
            <div className="flex bg-slate-100 border-b text-sm font-medium text-slate-500">
              <button onClick={() => setVistaActual('pdf')} className={`flex-1 p-3 flex justify-center items-center gap-2 ${vistaActual === 'pdf' ? 'bg-white text-blue-600 border-b-2 border-blue-600' : 'hover:bg-slate-200'}`}><FileText size={16}/> Visor de Boleta PDF</button>
              <button onClick={() => setVistaActual('consolidado')} className={`flex-1 p-3 flex justify-center items-center gap-2 ${vistaActual === 'consolidado' ? 'bg-white text-amber-600 border-b-2 border-amber-600' : 'hover:bg-slate-200'}`}><LayoutList size={16}/> Consolidado del Salón</button>
            </div>

            <div className="flex-1 bg-slate-50 flex items-center justify-center overflow-auto p-4">
              {vistaActual === 'pdf' && (
                pdfPreview ? ( <iframe src={pdfPreview} title="Vista previa del PDF" className="w-full h-full min-h-[550px] border border-slate-300 rounded shadow-sm bg-white" /> ) : (
                  <div className="text-center p-8"><Eye size={64} className="mx-auto text-slate-300 mb-4" /><p className="text-slate-500 font-medium">Selecciona un alumno y previsualiza su boleta aquí.</p></div>
                )
              )}

              {vistaActual === 'consolidado' && (
                consolidado.length > 0 ? (
                  <div className="w-full h-full bg-white rounded shadow-sm border border-slate-200">
                    <table className="w-full text-left border-collapse">
                      <thead className="bg-slate-100 border-b sticky top-0">
                        <tr><th className="p-4 font-bold text-slate-600 text-center w-20">Mérito</th><th className="p-4 font-bold text-slate-600">Apellidos y Nombres</th><th className="p-4 font-bold text-slate-600 text-center">Faltas</th><th className="p-4 font-bold text-slate-600 text-center">Promedio General</th></tr>
                      </thead>
                      <tbody>
                        {consolidado.map((item) => (
                          <tr key={item.id} className="border-b hover:bg-slate-50 transition-colors">
                            <td className="p-4 text-center">
                              {item.puesto === 1 && <span className="bg-yellow-100 text-yellow-700 px-3 py-1 rounded-full font-black flex items-center justify-center gap-1 mx-auto w-16"><Trophy size={14}/> 1°</span>}
                              {item.puesto === 2 && <span className="bg-slate-200 text-slate-600 px-3 py-1 rounded-full font-black mx-auto block w-12">2°</span>}
                              {item.puesto === 3 && <span className="bg-orange-100 text-orange-800 px-3 py-1 rounded-full font-black mx-auto block w-12">3°</span>}
                              {item.puesto > 3 && <span className="text-slate-500 font-medium">{item.puesto}°</span>}
                            </td>
                            <td className="p-4 font-medium text-slate-800">{item.nombreCompleto}</td>
                            <td className="p-4 text-center text-slate-500">{item.faltas}</td>
                            <td className="p-4 text-center font-bold text-blue-600 text-lg">{item.promedioExacto.toFixed(2)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : ( <div className="text-center p-8"><Trophy size={64} className="mx-auto text-amber-200 mb-4" /><p className="text-slate-500 font-medium">Haz clic en "Ver Orden de Mérito" para calcular el ranking.</p></div> )
              )}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};
export default Boletas;